import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { TransferRequest } from '@daml.js/utility-registry-v0/lib/Utility/Registry/V0/Holding/Transfer';
import { ERR_REJ_XFER_REQ, SUC_REJ_XFER_REQ } from '../../../../utils/strings';

export const useRejectTransferRequest = () => {
  const { submit } = useExerciseSubmission(
    TransferRequest.TransferRequest_Reject,
    SUC_REJ_XFER_REQ,
    ERR_REJ_XFER_REQ,
  );
  return submit;
};
